import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { InvitationDTO, InvitationService } from '../../services/invitation.service';

@Component({
  selector: 'app-invitation-response',
  standalone: false,
  templateUrl: './invitation-response.component.html',
  styleUrl: './invitation-response.component.sass'
})
export class InvitationResponseComponent implements OnInit {
  isLoading = true;
  invitationId: number;
  invitation: InvitationDTO | null = null;
  isExpired = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private snackBar: MatSnackBar,
    private invitationService: InvitationService
  ) {}

  ngOnInit(): void {
    this.invitationId = +(this.route.snapshot.paramMap.get('invitationId') as string);
    this.loadInvitation();
  }

  loadInvitation(): void {
    this.isLoading = true;
    this.invitationService.getInvitation(this.invitationId).subscribe({
      next: (invitation) => {
        this.invitation = invitation;
        this.isExpired = new Date(invitation.expirationTime).getTime() < new Date().getTime();
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
        this.snackBar.open('Não foi possível carregar o convite.', 'Fechar', { duration: 4000 });
      }
    });
  }

  onAccept(): void {
    if (!this.invitationId) { return; }
    this.invitationService.acceptInvitation(this.invitationId).subscribe({
      next: () => {
        this.snackBar.open('Convite aceito com sucesso.', 'Fechar', { duration: 4000 });
        this.router.navigate(['/condominiums']);
      },
      error: () => {
        this.snackBar.open('Não foi possível aceitar o convite.', 'Fechar', { duration: 4000 });
      }
    });
  }

  onReject(): void {
    if (!this.invitationId) { return; }
    // Utiliza atualização para marcar como não aceito
    this.invitationService.updateInvitation(this.invitationId, { accepted: false }).subscribe({
      next: () => {
        this.snackBar.open('Convite rejeitado.', 'Fechar', { duration: 4000 });
        this.router.navigate(['/condominiums']);
      },
      error: () => {
        this.snackBar.open('Não foi possível rejeitar o convite.', 'Fechar', { duration: 4000 });
      }
    });
  }

  onBack(): void {
    this.router.navigate(['/condominiums']);
  }
}
